"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ecommerce_1 = require("../../api/ecommerce");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class ContactPersonStore {
    api = new ecommerce_1.ContactPersonApi(configuration_1.default);
    customers = new Map();
    loading = false;
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            customers: mobx_1.observable,
            loading: mobx_1.observable,
            isLoading: mobx_1.computed,
            customerList: mobx_1.computed,
            loadContactPersons: mobx_1.action.bound,
        });
    }
    get isLoading() {
        return this.loading;
    }
    get customerList() {
        return Array.from(this.customers.values());
    }
    findCustomerByExternalId(externalId) {
        return this.customerList.find((customer) => externalId === customer.extensions?.massiveCustomer?.externalId);
    }
    getLicenseContactId(customerId) {
        return this.customers.get(customerId)?.extensions?.massiveCustomer?.externalId ?? null;
    }
    loadContactPersons() {
        this.customers.clear();
        this.loading = true;
        return this.api
            .readContactPersons()
            .then((customers) => {
            customers.forEach((customer) => {
                this.customers.set(customer.id, customer);
            });
            return this.customers;
        })
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
    deleteContactPerson(externalId) {
        return this.api.deleteContactPerson({ id: externalId });
    }
}
exports.default = new ContactPersonStore();
